import { useRef } from "react";
import { useEditIncMutation, useGetWardsQuery } from "./wardSlice";


const EditInc = ({ refOpen, editINC, setEditINC }) => {
    const {
        data: wards,
        isSuccess,
        isError,
        error
    } = useGetWardsQuery('getWards');
    const [editINCData, { isLoading }] = useEditIncMutation()

    const handleChange = (e) => {
        setEditINC({ ...editINC, [e.target.name]: e.target.value })
    }
    const refClose = useRef(null)
    const refCloseINC = useRef(null)

    const handleClick = async (e) => {
        e.preventDefault()

        try {
            refCloseINC.current.click();
            await editINCData({ inc_id: editINC?.inc_id, inc_name: editINC?.inc_name, inc_leave: editINC?.inc_leave, inc_blocked: editINC?.inc_blocked, inc_ward_id: editINC?.inc_ward_id }).unwrap()
            setEditINC({ inc_id: "", inc_name: "", inc_leave: "", inc_blocked: "", inc_ward_id: "" });
            console.log(refClose.current, "current");

        }
        catch (e) {
            console.error("Error in community edit", e)
        }

    }
    return (
        <>
            <button ref={refOpen} type="button" className="btn d-none" data-bs-toggle="offcanvas" data-bs-target="#depOffCanvas1" aria-controls="depOffCanvas1"></button>

            <div className="offcanvas offcanvas-end" data-bs-scroll="true" data-bs-backdrop="false" tabIndex="-1" id="depOffCanvas1" aria-labelledby="depOffCanvas1">
                <div className="offcanvas-header">
                    <h5 className="offcanvas-title" id="offcanvas1Label">Edit Inc</h5>
                    <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close" ref={refCloseINC}></button>
                </div>
                <div className="offcanvas-body">
                    <div>
                        <form className="row g-3">
                            <div className="col-md-12 text-left">
                                <label htmlFor="ename" className="form-label font-weight-bold">
                                    Name
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="community_name"
                                    name="inc_name"
                                    value={editINC?.inc_name}
                                    onChange={handleChange}
                                    placeholder="Name"
                                    autoComplete="off"
                                    required
                                />
                            </div>
                            <div className="col-md-12 text-left">
                                <label htmlFor="ename" className="form-label font-weight-bold">
                                    Leave
                                </label>
                                <select className="form-select" value={editINC?.inc_leave}
                                    onChange={handleChange} id="community_type" name="inc_leave" required>
                                    <option value="">--Select--</option>
                                    <option value="1">Yes</option>
                                    <option value="0">No</option>
                                </select>
                            </div>
                            <div className="col-md-12 text-left">
                                <label htmlFor="ename" className="form-label font-weight-bold">
                                    Blocked
                                </label>
                                <select className="form-select" value={editINC?.inc_blocked}
                                    onChange={handleChange} id="community_type" name="inc_blocked" required>
                                    <option value="">--Select--</option>
                                    <option value="1">Yes</option>
                                    <option value="0">No</option>
                                </select>
                            </div>
                            <div className="col-md-12 text-left">
                                <label htmlFor="ename" className="form-label font-weight-bold">
                                    ward id
                                </label>
                                <select className="form-select" value={editINC?.inc_ward_id}
                                    onChange={handleChange} id="community_type" name="inc_ward_id" required>
                                    <option value="">--Select--</option>
                                    {wards?.ids?.map((e) => {
                                        return <option value={wards?.entities[e]?.ward_id}>{wards?.entities[e]?.ward_number}</option>
                                    })}
                                </select>
                            </div>

                            <div className="col-md-12">
                                <button type="submit" className="btn btn-ff9b44 btn-block btn-round" onClick={handleClick}>
                                    {isLoading ? <i className="fa fa-spinner fa-spin"></i> : "Submit"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}

export default EditInc